import http from '@/services/axios'
import state from '@/vuex/state'
import store from '@/vuex'

const auth = {
  login: (data) => {
    let response = http.post('/auth/parceiro/login', data)
    return response
  },
  loggedIn: () => {
    if (state.Usuario.id == null) store.commit('INITIALISE_STORE')
    return state.Usuario.id != null
  },
  recover: (data) => {
    let response = http.post('/auth/recover', data)
    return response
  },
  change: (data) => {
    let response = http.post('/auth/change', data)
    return response
  },
  isAdministrador() {
    if (state.Usuario.id == null) store.commit('INITIALISE_STORE')
    return state.Usuario.perfil === 'A'
  }
}

export default { ...auth }



// WEBPACK FOOTER //
// ./src/modules/Auth/services/index.js